var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKickstand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 543 543",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 305 236 C 281 307 257 378 234 450 219 496 187 518 141 522 133 522 125 523 118 523 103 523 92 512 92 498 91 484 102 474 118 473 131 472 143 471 154 468 169 465 179 455 184 441 199 397 214 355 228 311 257 221 286 131 314 42 319 29 328 21 342 21 370 20 399 20 427 21 442 21 452 30 452 46 453 71 453 96 452 121 452 137 442 146 427 146 396 147 365 147 333 147 324 176 314 205 305 236 Z M 403 77 C 403 72 402 70 396 70 389 71 381 71 374 70 367 70 366 73 366 78 366 97 366 97 384 97 404 97 403 97 403 77 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickstand);
export default __webpack_public_path__ + "static/media/kickstand.cf087a788abdb4fa9c119629397d6861.svg";
export { ForwardRef as ReactComponent };